import React from 'react';


export const Php = props => {
    return (
        <img className={props.className} src={require('../../../resources/images/png_icons/php.png')} />
    )
};
